<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 0.638885C10.4142 0.638885 10.75 0.974672 10.75 1.38889V2.5C10.75 2.91421 10.4142 3.25 10 3.25C9.58579 3.25 9.25 2.91421 9.25 2.5V1.38889C9.25 0.974672 9.58579 0.638885 10 0.638885Z"
            fill="currentColor"
        />
        <path
            d="M16.6192 3.38077C16.9121 3.67367 16.9121 4.14854 16.6192 4.44143L15.8337 5.22699C15.5408 5.51988 15.0659 5.51988 14.773 5.22699C14.4801 4.9341 14.4801 4.45922 14.773 4.16633L15.5586 3.38077C15.8515 3.08788 16.3263 3.08788 16.6192 3.38077Z"
            fill="currentColor"
        />
        <path
            d="M17.5 9.25C17.0858 9.25 16.75 9.58579 16.75 10C16.75 10.4142 17.0858 10.75 17.5 10.75H18.6111C19.0253 10.75 19.3611 10.4142 19.3611 10C19.3611 9.58579 19.0253 9.25 18.6111 9.25H17.5Z"
            fill="currentColor"
        />
        <path
            d="M14.773 14.773C15.0659 14.4801 15.5408 14.4801 15.8337 14.773L16.6192 15.5586C16.9121 15.8515 16.9121 16.3263 16.6192 16.6192C16.3263 16.9121 15.8515 16.9121 15.5586 16.6192L14.773 15.8337C14.4801 15.5408 14.4801 15.0659 14.773 14.773Z"
            fill="currentColor"
        />
        <path
            d="M10.75 17.5C10.75 17.0858 10.4142 16.75 10 16.75C9.58579 16.75 9.25 17.0858 9.25 17.5V18.6111C9.25 19.0253 9.58579 19.3611 10 19.3611C10.4142 19.3611 10.75 19.0253 10.75 18.6111V17.5Z"
            fill="currentColor"
        />
        <path
            d="M5.22702 14.773C5.51991 15.0659 5.51991 15.5408 5.22702 15.8337L4.44146 16.6192C4.14857 16.9121 3.6737 16.9121 3.3808 16.6192C3.08791 16.3263 3.08791 15.8515 3.3808 15.5586L4.16636 14.773C4.45925 14.4801 4.93413 14.4801 5.22702 14.773Z"
            fill="currentColor"
        />
        <path
            d="M1.38892 9.25C0.974702 9.25 0.638916 9.58579 0.638916 10C0.638916 10.4142 0.974702 10.75 1.38892 10.75H2.50003C2.91424 10.75 3.25003 10.4142 3.25003 10C3.25003 9.58579 2.91424 9.25 2.50003 9.25H1.38892Z"
            fill="currentColor"
        />
        <path
            d="M3.3808 3.38077C3.6737 3.08788 4.14857 3.08788 4.44146 3.38077L5.22702 4.16633C5.51991 4.45922 5.51991 4.93409 5.22702 5.22699C4.93413 5.51988 4.45925 5.51988 4.16636 5.22699L3.3808 4.44143C3.08791 4.14854 3.08791 3.67367 3.3808 3.38077Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0001 4.52777C6.97783 4.52777 4.52783 6.97777 4.52783 9.99999C4.52783 13.0222 6.97783 15.4722 10.0001 15.4722C13.0223 15.4722 15.4723 13.0222 15.4723 9.99999C15.4723 6.97777 13.0223 4.52777 10.0001 4.52777ZM6.02783 9.99999C6.02783 7.8062 7.80626 6.02777 10.0001 6.02777C12.1939 6.02777 13.9723 7.8062 13.9723 9.99999C13.9723 12.1938 12.1939 13.9722 10.0001 13.9722C7.80626 13.9722 6.02783 12.1938 6.02783 9.99999Z"
            fill="currentColor"
        />
    </svg>
</template>
